module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new":"New Deployment","type":"Deployment Type","welcome":"Goal"}}')
  delete Component.options._Ctor
}
